import React from "react";
import styled from "styled-components";
import { IonModal, IonTitle, IonToolbar } from "@ionic/react";

type Props = {
  isOpen: boolean;
  title: string;
  sections: Record<string, string[]>;
  selectedTags: string[];
  onClose: () => void;
  onToggleTag: (tag: string) => void;
};

const VideoFiltersModal: React.FC<Props> = ({
  isOpen,
  title,
  sections,
  selectedTags,
  onClose,
  onToggleTag,
}) => {
  return (
    <IonModal
      className="resonance-sheetmodal"
      isOpen={isOpen}
      backdropDismiss={true}
      onWillDismiss={onClose}
      initialBreakpoint={1}
      breakpoints={[0, 1]}
      canDismiss={true}
    >
      <IonToolbar>
        <IonTitle>{title}</IonTitle>
        <CloseButton slot="end" onClick={onClose}>
          ×
        </CloseButton>
      </IonToolbar>

      <>
        {Object.entries(sections).map(([section, tags]) => (
          <Section key={section}>
            <SectionTitle>{section}</SectionTitle>
            <TagList>
              {tags.map((tag) => (
                <FilterTag
                  key={tag}
                  onClick={() => onToggleTag(tag)}
                  selected={selectedTags.includes(tag)}
                >
                  {tag}
                </FilterTag>
              ))}
            </TagList>
          </Section>
        ))}
      </>
    </IonModal>
  );
};

export default VideoFiltersModal;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 10;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
`;

const Section = styled.div`
  margin-bottom: 20px;
`;

const SectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  color: #444;
`;

const TagList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`;

const FilterTag = styled.button<{ selected: boolean }>`
  background-color: ${(p) => (p.selected ? "#FFCE48" : "white")};
  color: ${(p) => (p.selected ? "black" : "#333")};
  font-weight: ${(p) => (p.selected ? 500 : 400)};
  border: 1px solid #ccc;
  padding: 8px 14px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease, color 0.2s ease;
`;